import { createContext } from "react";
export let FluentContext = createContext(null);
